import { bgAnime } from './_bg-animation.js';
import { page } from './_page.js';

document.addEventListener('DOMContentLoaded', ()=>{
    bgAnime.init();
    page.init();
})
